import React from "react";

export default function({infoArray}){
  if(!Array.isArray(infoArray) || !infoArray.length){return ''}
  return infoArray.map((info) => {
    return` <span style="padding:0px 0px; font-size:14px; color: #222222">- ${info}</span>`
  })?.join("");


}